import { Button } from '@synoptic/ui-kit/button/button.tsx';
import { ReactNode, useState } from 'react';
import { useParams } from 'react-router';
import { ConfirmModal } from '@/components/confirm-modal/confirm-modal.tsx';
import { usePublishStream } from '@/components/streams/publish-stream/use-publish-stream.ts';

export const PublishStreamModal = ({ trigger }: { trigger: ReactNode }) => {
  const id = useParams().id as string;
  const [open, onOpenChange] = useState(false);
  const [publishStream, { loading }] = usePublishStream(id);

  const onPublish = async () => {
    await publishStream();
    onOpenChange(false);
  };

  return (
    <ConfirmModal
      isOpen={open}
      onOpenChange={onOpenChange}
      title="Publish stream"
      description={'Are you ready to publish this stream?'}
      submitButton={
        <Button loading={loading} onClick={onPublish} variant={'primary'}>
          Publish now
        </Button>
      }
    >
      {trigger}
    </ConfirmModal>
  );
};
